<template>
  <div class="container">
    <div class="privacy-content">
      <div class="content">
        <div class="title" ref="titleEl">{{decryptLabel(companyTitle)}}</div>
        <div class="party-b-company">{{decryptLabel(companyName)}}</div>
        <div class="name">{{info.username}}</div>
        <div class="idnum">{{info.id_num}}</div>
        <div class="mobile">{{info.mobile}}</div>
        <div class="money">{{info.money}}</div>
        <div class="Dmoney">{{Dmoney}}</div>
        <div class="repaytime">{{repaytime}}</div>
        <div class="year">{{year}}</div>
        <div class="moth">{{moth}}</div>
        <div class="ri">{{ri}}</div>
        <div class="repayyear">{{repayyear}}</div>
        <div class="moth1">{{moth1}}</div>
        <div class="ri1">{{ri1}}</div>
        <div class="rate">{{info.rate*100}}</div>
        <div class="name1">{{info.username}}</div>
        <div class="time">{{year}} 年 {{moth}} 月 {{ri}} 日</div>
        <img class="yz-image" src="@/assets/images/yz.png">
      </div>
    </div>
    <button class="back-btn" @click="goBack">返回</button>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      companyTitle: 'pKfOMidiQz8kQRm38IYIWxqeficwWbDB7I79Y6qYH9rKvz+PHy4TFt3EmdbUVNvk',
      companyName: 'pKfOMidiQz8kQRm38IYIWzZSZJOwStXJncSJog2mYzs=',
      Dmoney: '',
      info: {},
      year: '',
      moth: '',
      moth1: '',
      ri: '',
      ri1: '',
      repaytime: '',
      repayyear: ''
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    getUserInfo() {
      try {
        let info = getStorage('userInfos') || {};
        
        if (!info || Object.keys(info).length === 0) {
          if (this.$store && this.$store.state && this.$store.state.user) {
            info = this.$store.state.user.userInfo || {};
          }
        }
        
        this.info = info;
        
        if (info.money) {
          this.Dmoney = this.numberToChinese(info.money);
        }
        
        if (info.repaymenttime && info.repaymenttime1) {
          try {
            var d = info.loantime.split("-");
            var d1 = info.repaymenttime1.split("-");
            this.year = d[0] || '';
            this.moth = d[1] ? parseInt(d[1]) : '';
            this.moth1 = d1[1] ? parseInt(d1[1]) : '';
            this.ri = d[2] ? parseInt(d[2]) : '';
            this.ri1 = d1[2] ? parseInt(d1[2]) : '';
            this.repayyear = d1[0] || '';
            
            var loanYear = parseInt(d[0]);
            var loanMonth = parseInt(d[1]);
            var repayYear = parseInt(d1[0]);
            var repayMonth = parseInt(d1[1]);
            
            this.repaytime = (d1[0] && this.year) ? ((repayYear - loanYear) * 12 + (repayMonth - loanMonth)) : 1;
            if (this.repaytime <= 0) {
              this.repaytime = 1;
            }
          } catch (e) {
            this.year = new Date().getFullYear();
            this.moth = new Date().getMonth() + 1;
            this.moth1 = this.moth;
            this.ri = new Date().getDate();
            this.ri1 = this.ri;
            this.repayyear = this.year;
            this.repaytime = 1;
          }
        } else {
          this.year = new Date().getFullYear();
          this.moth = new Date().getMonth() + 1;
          this.moth1 = this.moth;
          this.ri = new Date().getDate();
          this.ri1 = this.ri;
          this.repayyear = this.year;
          this.repaytime = 1;
        }
      } catch (error) {
        this.info = {};
        this.Dmoney = '';
        this.year = new Date().getFullYear();
        this.moth = new Date().getMonth() + 1;
        this.moth1 = this.moth;
        this.ri = new Date().getDate();
        this.repayyear = this.year;
        this.repaytime = 1;
      }
      this.autoScaleTitle();
    },
    numberToChinese(n) {
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)){
        return "数据非法";
      }
      
      var unit = "千百拾亿千百拾万千百拾元角分", str = "";
      n += "00";
      
      var indexpoint = n.indexOf('.');
      
      if (indexpoint >= 0){
        n = n.substring(0, indexpoint) + n.substr(indexpoint+1, 2);
      }
      
      unit = unit.substr(unit.length - n.length);
      for (var i=0; i < n.length; i++){
        str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
      }
      
      return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    },
    autoScaleTitle() {
      this.$nextTick(() => {
        const el = this.$refs.titleEl;
        if (!el) return;
        const parent = el.parentElement;
        if (!parent) return;
        const maxWidth = parent.clientWidth * 0.9;
        const baseSize = 0.8;
        let fontSize = baseSize;
        el.style.fontSize = fontSize + 'rem';
        while (el.scrollWidth > maxWidth && fontSize > 0.3) {
          fontSize -= 0.05;
          el.style.fontSize = fontSize + 'rem';
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.privacy-content {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
}

.content{
  height: 150rem;
  background-image: url(~@/assets/images/dzht.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  font-size: 0.65rem;
  position: relative;
}

.title{
  position: absolute;
  top: 0.6%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.8rem;
  font-weight: bold;
  white-space: nowrap;
}

.lender-company{
  position: absolute;
  top: 5.4%;
  left: 40%;
}

.party-b-company{
  position: absolute;
  top: 5.4%;
  left: 25%;
}

.name{  
  position: absolute;
  top: 1.80%;
  left: 26%;
}

.idnum{
  position: absolute;
  top: 3.0%;
  left: 22%;
}

.mobile{
  position: absolute;
  top: 4.18%;
  left: 19%;
}

.money{
  position: absolute;
  top: 11.06%;
  left: 37.5%;
}

.Dmoney{
  position: absolute;
  top: 11.06%;
  left: 59.8%;
}

.repaytime{
  position: relative;
  top: 16.00%;
  left: 30.3%;
}

.year{
  position: absolute;
  top: 16.0%;
  left: 39.3%;
}

.moth{
  position: absolute;
  top: 16.0%;
  left: 47.1%;
}

.ri{
  position: absolute;
  top: 16.0%;
  left: 52.5%;
}

.repayyear{
  position: absolute;
  top: 16.0%;
  left: 59%;
}

.moth1{
  position: absolute;
  top: 16.0%;
  left: 68.0%;
}

.ri1{
  position: absolute;
  top: 16.0%;
  left: 73.0%;
}

.rate{
  position: absolute;
  top: 19.25%;
  left: 11.8%;
}

.name1{
  position: absolute;
  top: 97.65%;
  left: 20.5%;
}

.time{
  position: absolute;
  top: 98.83%;
  left: 70.5%;
}

.yz-image{
  width: 100px;
  height: 100px;
  position: absolute;
  top: 95.83%;
  left: 65.5%;
}

.back-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #ff9800;
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
</style>
